import { attempt, isError } from 'lodash';

export function validateRichText(value) {
  const parsedContent = attempt(JSON.parse, value);
  return (
    !isError(parsedContent) &&
    parsedContent?.some((item) => item.children.some((c) => c.text))
  );
}
